/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const HistoryContext = createContext();

export const useHistoryContext = () => useContext(HistoryContext);

export const HistoryProvider = ({ children }) => {
  const [history, setHistory] = useState([]);

  const getAnalysisCount = () => {
    return history.filter((entry) => entry.type === "Análise de Código").length;
  };

  // Carregar histórico do backend ao iniciar
  useEffect(() => {
    const fetchHistory = async () => {
      const token = localStorage.getItem("token"); // Recupera o token do localStorage
      if (!token) {
        return;
      }
      try {
        const response = await axios.get("https://codefort.onrender.com/api/history", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setHistory(response.data);
        localStorage.setItem("history", JSON.stringify(response.data));
      } catch (error) {
        const localHistory = localStorage.getItem("history");
        if (localHistory) {
          setHistory(JSON.parse(localHistory));
        }
      }
    };
    fetchHistory();
  }, []);

  const addToHistory = async (entry) => {
    const token = localStorage.getItem("token"); // Recupere o token do localStorage

    if (!token) {
      return;
    }

    try {
      const response = await axios.post(
        "https://codefort.onrender.com/api/history",
        entry,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Atualizar localmente
      setHistory((prevHistory) => [...prevHistory, entry]);
    } catch (error) {}
  };

  return (
    <HistoryContext.Provider
      value={{ history, addToHistory, setHistory, getAnalysisCount }}
    >
      {children}
    </HistoryContext.Provider>
  );
};
